export default __webpack_public_path__ + "static/sticky_atc-e08daf3608d4628308fb7b7f70a2429b.png";